export enum AutopilotAckTypeEnum {
    Unknown,
    Success,
    MissingData,
    Inconsistent,
    Invalid
}
